<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g id="delete">
            <path id="Vector" d="M18 5C18.55 5 19 5.45 19 6C19 6.55 18.55 7 18 7H6C5.45 7 5 6.55 5 6C5 5.45 5.45 5 6 5H8.5L9.21 4.29C9.39 4.11 9.65 4 9.91 4H14.09C14.35 4 14.61 4.11 14.79 4.29L15.5 5H18ZM7 9H17C17.2652 9 17.5196 9.10536 17.7071 9.29289C17.8946 9.48043 18 9.73478 18 10V18C18 18.5304 17.7893 19.0391 17.4142 19.4142C17.0391 19.7893 16.5304 20 16 20H8C7.46957 20 6.96086 19.7893 6.58579 19.4142C6.21071 19.0391 6 18.5304 6 18V10C6 9.73478 6.10536 9.48043 6.29289 9.29289C6.48043 9.10536 6.73478 9 7 9Z"/>
        </g>
    </svg>
</template>
